// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"SubmitButton_submitButton__1-vfT","reducedFontSize":"SubmitButton_reducedFontSize__557VO"};